<template>
  <div>
    <div style="clear: both"></div>
    <v-layout row class="mt-2 py-2 mx-4">
      <v-flex md6 xs1 v-if="$mq !== 'sm'"> </v-flex>
      <v-flex xs12 md6>
        <div
          class="d-flex d-flex-initial align-center"
          :class="{ 'justify-end': $mq != 'sm', 'justify-center': $mq == 'sm' }"
        >
          <div class="mr-3" v-if="$mq !== 'sm' && $mq !== 'md'">Filtres :</div>
          <v-badge color="red" overlap class="mr-2">
            <template v-slot:badge v-if="activeProposalsNotifsCount > 0">
              <span>{{ activeProposalsNotifsCount }}</span>
            </template>
            <v-chip :selected="true">
              <v-checkbox v-model="showActive" label=""> </v-checkbox>

              <v-icon title="Actifs" v-if="$mq === 'sm'">thumb_up</v-icon>
              <span v-else>Actifs</span>
            </v-chip>
          </v-badge>
          <v-badge color="red" overlap class="mr-2">
            <template v-slot:badge v-if="notLikedProposalsNotifsCount > 0">
              <span>{{ notLikedProposalsNotifsCount }}</span>
            </template>
            <v-chip :selected="true">
              <v-checkbox v-model="showNotLiked" label=""> </v-checkbox>
              <v-icon title="Pas aimés" v-if="$mq === 'sm'">thumb_down</v-icon>
              <span v-else>Pas aimés</span>
            </v-chip>
          </v-badge>
          <v-badge color="red" overlap>
            <template v-slot:badge v-if="disabledProposalsNotifsCount > 0">
              <span>{{ disabledProposalsNotifsCount }}</span>
            </template>
            <v-chip :selected="true">
              <v-checkbox v-model="showDisabled" label=""> </v-checkbox>
              <v-icon title="Indisponibles" v-if="$mq === 'sm'">block</v-icon>
              <span v-else>Indisponibles</span>
            </v-chip>
          </v-badge>
        </div>
      </v-flex>
    </v-layout>

    <div class="cards">
      <v-card
        class="mt-1 mb-1 px-3 py-2 mx-2 d-flex justify-center"
        color="#EFEFEF"
        v-if="proposals.length === 0"
      >
        Pas de propositions (pour l'instant :) )
      </v-card>
      <v-container fluid>
        <v-layout row wrap style="align-items: stretch">
          <v-flex xs12 lg4 md6 v-for="p in proposals" class="mb-4">
            <ProposalCard
              :proposal="p"
              no-results="Pas de nouvelles propositions"
              style="height: 100%"
              :sortable="p.__sortable"
              :class="{
                disabled: p.disabled,
                liked: p.liked,
                disliked: p.disliked
              }"
              @updatePosition="updatePosition"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>
<script>
import ProposalCard from "../components/proposal/ProposalCard";
import { fetchHil } from "../utils";
export default {
  components: { ProposalCard },
  data() {
    return {
      tab: 0,
      loading: false,
      showDisabled: false,
      showPlanned: false,
      showActive: true,
      showNotLiked: false
    };
  },

  async mounted() {
    this.loading = true;
    await this.$store.dispatch("fetchProposals", {
      id: this.$route.params.lease_id
    });
    this.loading = false;
  },

  computed: {
    proposals() {
      let proposals = [];
      if (this.showActive) {
        proposals = [
          ...proposals,
          ...this.activeProposals.map(ap => ({ ...ap, __sortable: true }))
        ];
      }
      if (this.showNotLiked) {
        proposals = [...proposals, ...this.notLikedProposals];
      }
      if (this.showDisabled) {
        proposals = [...proposals, ...this.disabledProposals];
      }
      return proposals.sort((a, b) => {
        if (a.disabled && !b.disabled) {
          return 1;
        }
        if (!b.disabled && a.disabled) {
          return 1;
        }
        if (!a.liked && !a.disliked) {
          return -1;
        }
        if (!b.liked && !b.disliked) {
          return 1;
        }
        return (a.disliked && b.disabled) ||
          (a.liked &&
            (b.disabled ||
              b.disliked ||
              (b.liked && a.position < b.position))) ||
          (!a.liked && !a.disliked && !b.disabled && (b.liked || b.disliked)) ||
          (a.visited?.dateVisite && !b.visited?.dateVisite)
          ? -1
          : 1;
      });
    },
    activeProposals() {
      return this.$store.state.currentProjectProposals.filter(p => {
        return (
          !p.disliked &&
          !p.disabled &&
          p.folderStatus !== "rejected" &&
          (!p.status || !p.status.startsWith("denied_"))
        );
      });
    },
    activeProposalsNotifsCount() {
      const ids = this.activeProposals.map(({ idSell }) => idSell);
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          ids.indexOf(idEstate) !== -1 &&
          idProject === this.$route.params.lease_id &&
          !seen
      ).length;
    },
    notLikedProposals() {
      return this.$store.state.currentProjectProposals.filter(p => {
        return p.disliked && !p.disabled;
      });
    },
    notLikedProposalsNotifsCount() {
      const ids = this.notLikedProposals.map(({ idSell }) => idSell);
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          ids.indexOf(idEstate) !== -1 &&
          idProject === this.$route.params.lease_id &&
          !seen
      ).length;
    },
    disabledProposals() {
      return this.$store.state.currentProjectProposals.filter(p => {
        return (
          p.disabled ||
          p.folderStatus === "rejected" ||
          (p.status && p.status.startsWith("denied_"))
        );
      });
    },
    disabledProposalsNotifsCount() {
      const ids = this.disabledProposals.map(({ idSell }) => idSell);
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          ids.indexOf(idEstate) !== -1 &&
          idProject === this.$route.params.lease_id &&
          !seen
      ).length;
    }
  },

  methods: {
    async updateProposal(proposal, position) {
      const resp = await fetchHil(
        `/proposals/lease/${proposal.idBuy}/host/${proposal.idSell}`,
        {
          method: "PUT",
          body: { position }
        }
      );
      if (!resp.ok) {
        console.error(await resp.text());
        this.showError = true;
        throw new Error("http error");
      }
    },

    async updatePosition({ proposal, value }) {
      proposal.liked = new Date();
      proposal.disliked = null;
      await this.updateProposal(proposal, value);
      await this.$store.dispatch("fetchProposals", {
        id: this.$route.params.lease_id
      });
    }
  }
};
</script>
<style scoped>
.liked {
  border-top: 10px solid green;
}
.disliked {
  border-top: 10px solid red;
}
</style>
